<template>
  <div class="unprivilege-panel" :class="css">
    <h5 v-if="title">{{title}}</h5>
    <i class="fa fa-lock" />
    <p>Please contact your admin to get access to this section</p>
  </div>
</template>

<script>
export default {
  name: 'UnprivilegePanel',
  props: {
    title: String,
    css: String
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  .unprivilege-panel {
    position: relative;
    background: $white;
    padding: 20px;
    text-align: center;
    border-radius: 15px;
    @include custom-flex(center, center, column);
    min-height: 200px;

    &.details-panel {
      height: calc(100vh - 160px);
    }
    &.settings-panel {
      height: calc(100vh - 180px);
    }
    &.section-panel {
      height: calc(100vh - 100px);
    }
    &.no-height {
      min-height: unset !important;
    }

    h5 {
      @include highlight-text();
      position: absolute;
      top: 20px;
      left: 20px;
    }

    i {
      color: $primary;
      margin: 10px 0;
      font-size: 20px;
    }

    p {
      @include normal-text($secondary, 15px, 500);
      margin: 10px 0;
    }
  }

  .desktop {
    .short-height {
      height: 300px;
    }

    .section-panel, .details-panel {
      width: 50% !important;
    }
  }
</style>
